import React, { Component } from "react";
import "./Contact.scss";

class Contact extends Component {
  render() {
    return (
      <div className="People">
        <script src="https://smtpjs.com/v3/smtp.js"></script>
        <div className="people-container animation">
          <h2> Grand Challenge Contacts </h2>
          <ul>
            {/*





For information related to this task, please contact: MINGJIE001@e.ntu.edu.sg. */}
            <li>
              Mingjie Lao (
              <a href="mailto:MINGJIE001@e.ntu.edu.sg.com?Subject=ActivityNet Challenge Inquiry">
                MINGJIE001@e.ntu.edu.sg
              </a>
              ), Nanyang Technological University
            </li>
            <li>
              Jingyuan Chen (
              <a href="mailto:jingyuan.cjy@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
                jingyuan.cjy@alibaba-inc.com
              </a>
              ) , Alibaba DAMO Academy
            </li>
            <li>
              Xiangyu Wang (
              <a href="mailto:david.wxy@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
                david.wxy@alibaba-inc.com
              </a>
              ), Alibaba DAMO Academy
            </li>
            {/* <li>
              Yao Liu (
              <a href="mailto:john.ly@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
                john.ly@alibaba-inc.com
              </a>
              ), Alibaba DAMO Academy
            </li> */}
            <li>
              {/* Liang Xia (liang.xial@alibaba-inc.com), Alibaba DAMO Academy */}
              Liang Xia (
              <a href="mailto:liang.xial@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
                liang.xial@alibaba-inc.com
              </a>
              ), Alibaba DAMO Academy
            </li>
            <li>
              {/* Jianqiang Huang (jianqiang.hjq@alibaba-inc.com), Alibaba DAMO Academy */}
              Jianqiang Huang (
              <a href="mailto:jianqiang.hjq@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
                jianqiang.hjq@alibaba-inc.com
              </a>
              ), Alibaba DAMO Academy
            </li>
            <li>
              Hanwang Zhang (
              <a href="mailto:hanwangzhang@e.ntu.edu.sg.com?Subject=ActivityNet Challenge Inquiry">
                hanwangzhang@e.ntu.edu.sg
              </a>
              ), Nanyang Technological University
            </li>
            <li>
              {/* Xian-Sheng Hua (xiansheng.hxs@alibaba-inc.com), Alibaba DAMO Academy */}
              Xian-Sheng Hua (
              <a href="mailto:xiansheng.hxs@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
                xiansheng.hxs@alibaba-inc.com
              </a>
              ), Alibaba DAMO Academy
            </li>
          </ul>
          <p>
            For information related to this task, please contact:
            MINGJIE001@e.ntu.edu.sg (
            <a href="mailto:MINGJIE001@e.ntu.edu.sg.com?Subject=ActivityNet Challenge Inquiry">
              MINGJIE001@e.ntu.edu.sg
            </a>
            )
            {/* <a href="mailto:jingyuan.cjy@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
              jingyuan.cjy@alibaba-inc.com
            </a>
            ,
            <a href="mailto:david.wxy@alibaba-inc.com?Subject=ActivityNet Challenge Inquiry">
              david.wxy@alibaba-inc.com
            </a> */}
            .
          </p>
        </div>
      </div>
    );
  }
}

export default Contact;
